var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1533 13.1484C13.619 13.1485 14 13.5139 14 13.9609C13.9999 14.4079 13.619 14.7734 13.1533 14.7734H2.99316C2.5275 14.7734 2.14556 14.408 2.14551 13.9609C2.14551 13.5139 2.52747 13.1484 2.99316 13.1484H13.1533ZM8.07812 1.22656C8.3021 1.22656 8.51759 1.31166 8.67578 1.46387L12.5615 5.19531C13.0949 5.70734 12.7143 6.58473 11.9609 6.58496H10.6143V10.6494C10.6142 11.0964 10.2332 11.4619 9.76758 11.4619H6.38086C5.91523 11.4619 5.53428 11.0964 5.53418 10.6494V6.58496H4.1875C3.43426 6.58474 3.06184 5.70739 3.59473 5.19531L7.48145 1.46387C7.63956 1.31177 7.8543 1.22664 8.07812 1.22656Z",
    fill: "#9D9DE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallIcon);
export default __webpack_public_path__ + "static/media/install-icon.ed533a38.svg";
export { ForwardRef as ReactComponent };